import Vue from 'vue'
import Router from 'vue-router'

import QuickEntryVbConfirm from "../components/pages/buy/quick-entry-vb-confirm.vue";
import QuickEntryOtp from "../components/pages/buy/quick-entry-otp.vue";
import QuickEntryVbForm from "../components/pages/buy/quick-entry-vb-form.vue";
import RegistrationCompleted from "../components/pages/registration/registration-completed.vue";
import BuyConfirm from "../components/pages/buy/buy-confirm.vue";
import BuyCompleted from "../components/pages/buy/buy-completed.vue";
import QuickEntryVbComplete from "../components/pages/buy/quick-entry-vb-complete.vue";

Vue.use(Router);

// baseタグのSPAのルート定義（order|mypage）
// コンポーネントからも参照できるようにインスタンスプロパティとして扱う
// インスタンス内からはthis.$routerBase OR $routerBaseでアクセス
const baseElement = document.getElementById('routerBase');
Vue.prototype.$routerBase = baseElement ? baseElement.getAttribute('href') : null;

export default new Router({
    mode: 'history',
    relative: true, // route baseを動的に変更する
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};   // 常に最上部を表示
    },
    routes: [
        {
            path: '/offer-with-registration',
            component: QuickEntryVbForm,
            name: 'QuickEntryVbForm',
        },
        {
            path: '/offer-with-registration/confirm',
            component: QuickEntryVbConfirm,
            name: 'QuickEntryVbConfirm',
        },
        {
            path: '/offer-with-registration/authentication',
            component: QuickEntryOtp,
            name: 'QuickEntryOtp',
            props: {
                formPathName: 'QuickEntryVbForm',
                completePathName: 'QuickEntryVbComplete'
            }
        },
        {
            path: '/offer-with-registration/completed',
            component: QuickEntryVbComplete,
            name: 'QuickEntryVbComplete',
            props: true,
        },
        {
            path: '/regist_comp',
            alias: [
                '/snslogin/amazon/regist_comp',
                '/snslogin/facebook/regist_comp',
                '/snslogin/google/regist_comp',
            ],
            component: RegistrationCompleted,
            name: 'RegistrationCompleted',
        },
        {
            path: '/sell/offer-thx-registration/confirm',
            component: BuyConfirm,
            name: 'BuyConfirm',
        },
        {
            path: '/sell/offer-thx-registration/completed',
            component: BuyCompleted,
            name: 'BuyCompleted',
        },
    ]
})